import { useLayout } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { getInnerActivePageId } from 'modules/common/selectors/navigationSelectors';
import { SimplePageLayout } from 'modules/page';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { useNewOrgPopupNoCompaniesSave } from 'shared/hooks/useNewOrgPopupNoCompaniesSave';

import { LOGIN_PAGE_ID, PAGE_ID } from '../../config';
import useLoginPageData from '../../hooks/useLoginPageData';
import LoginPageContent from './LoginPageContent';

const LoginPage = memo(() => {
    const activePageId = useSelector(selectors.navigation.getActivePageId);
    const innerActivePageId = useSelector(getInnerActivePageId);

    useLayout({ containerMinSize: 'xxsmall' });
    useNewOrgPopupNoCompaniesSave();
    useLoginPageData();

    if (innerActivePageId !== LOGIN_PAGE_ID || activePageId !== PAGE_ID) {
        return <SimplePageLayout />;
    }

    return <LoginPageContent />;
});

LoginPage.displayName = 'LoginPage';

export default LoginPage;
